<div class="container-fluid py-4">
    <!-- Header del reporte -->
    <div class="row align-items-center mb-4">
        <div class="col-md-4 text-center text-md-start">
            <img class="logo img-fluid" src="./assets/img/logo.jpeg" alt="Logo Uturunco Studio"
                style="max-height: 80px;">
            <div class="mt-2">
                <h5 class="mb-0 fw-bold">Uturunco Studio</h5>
                <small class="text-muted">Empresa independiente de desarrollo de software</small>
            </div>
        </div>

        <div class="col-md-4 text-center">
            <h3 class="mb-1 fw-bold text-primary">Reporte de Cajas</h3>
            <h6 class="text-muted">Control de ingresos, egresos y cortes</h6>
        </div>

        <div class="col-md-4 text-center text-md-end">
            <small class="text-muted">
                Resistencia, Chaco<br>
                {{ fecha | date:'dd MM yyyy' }}
            </small>
        </div>
    </div>

    <!-- Filtros -->
    <div class="card shadow-sm mb-4">
        <div class="card-body">
            <app-fil-caja (filter)="doFound($event)"></app-fil-caja>
        </div>
    </div>

    <!-- Resultados -->
    <div class="card shadow-sm">
        <div class="card-header bg-light d-flex justify-content-between align-items-center">
            <h5 class="mb-0">Listado de cajas</h5>
            <small class="text-muted" *ngIf="items?.length > 0">
                {{ items.length }} caja{{ items.length !== 1 ? 's' : '' }} encontrada{{ items.length !== 1 ? 's' : '' }}
            </small>
        </div>

        <div class="card-body p-0">
            <!-- Loading overlay -->
            <div *ngIf="loading" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Cargando...</span>
                </div>
                <p class="mt-3 text-muted">Obteniendo movimientos de cajas...</p>
            </div>

            <!-- Tabla con datos -->
            <div class="table-responsive" *ngIf="!loading">
                <table id="tblData" class="table table-hover table-bordered mb-0">
                    <thead class="table-dark">
                        <tr>
                            <th>Fecha apertura</th>
                            <th>Gastos | egresos</th>
                            <th>Ventas | ingresos</th>
                            <th>Saldo</th>
                            <th>Corte Caja</th>
                            <th>Detalle</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of items"
                            [ngClass]="{'table-success': item.isOpen, 'table-warning': !item.isOpen && item.saldo < 0}">
                            <td>{{ item.created_at | date:'dd-MM-yyyy HH:mm:ss' }}</td>
                            <td class="text-end">{{ item.egresos | currency:'$ ' }}</td>
                            <td class="text-end">{{ item.ingresos | currency:'$ ' }}</td>
                            <td class="text-end fw-bold">{{ item.saldo | currency:'$ ' }}</td>
                            <td>
                                <ng-container *ngIf="!item.isOpen">
                                    {{ item.importe | currency:'$ ' }} <small class="text-muted">({{ item.updated_at |
                                        date:'dd-MM-yyyy HH:mm' }})</small>
                                </ng-container>
                                <span *ngIf="item.isOpen" class="badge bg-warning text-dark">Caja abierta</span>
                            </td>
                            <td class="text-center">
                                <button *ngIf="!item.isOpen" (click)="select(item)" type="button"
                                    class="btn btn-primary btn-sm" data-toggle="modal" data-target="#modelId">
                                    <i class="fas fa-eye"></i> Ver
                                </button>
                                <span *ngIf="item.isOpen" class="text-muted">—</span>
                            </td>
                        </tr>

                        <!-- Mensaje sin datos -->
                        <tr *ngIf="items?.length === 0 && !loading">
                            <td colspan="6" class="text-center text-muted py-4">
                                <i class="fas fa-info-circle fa-2x mb-2"></i><br>
                                No se encontraron cajas en el período/filtro seleccionado.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Footer con resumen -->
        <div class="card-footer text-end bg-light" *ngIf="items?.length > 0 && !loading">
            <small class="text-muted me-3">
                Cajas abiertas: <strong class="text-warning">{{ cajasAbiertas }}</strong>
            </small>
            <small class="text-muted">
                Total registradas: <strong>{{ totalCajas }}</strong>
            </small>
        </div>
    </div>

    <!-- Modal (mantenido igual, solo estética) -->
    <div class="modal fade" id="modelId" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Detalle de caja</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="container-fluid">
                        <app-detalle-caja-2 [idCaja]="item?.id"></app-detalle-caja-2>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cerrar</button>
                </div>
            </div>
        </div>
    </div>

</div>